import * as React from 'react';

// ownFunctions
import * as Functions from './ProviderSelectorFunctions';
import { Provider } from '../../../../models/Entities/Provider/Provider';
import { Person } from '../../../../models/Entities/Person/Person';
import { IPersonaProps } from '@fluentui/react';
import { Avatar, Field, Spinner, Tag, TagPicker, TagPickerControl, TagPickerGroup, TagPickerInput, TagPickerList, TagPickerOption, TagPickerProps } from '@fluentui/react-components';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { use } from 'i18next';

const ProviderSelectorComponent = (props: Functions.Props) => {
  
  useEffect(() => {
    props.GetAllProviders(1, 1000, '');
  }, []);

  const [InternalProtocolPatientsSelected, setInternalProtocolPatientsSelected] = useState<Provider[]>([]);

  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

  const onOptionSelect: TagPickerProps["onOptionSelect"] = (e, data) => {
    if (data.selectedOptions?.length === 0) {
      setSelectedOptions([]);
      setInternalProtocolPatientsSelected([]);
      props.onChangeSelection && props.onChangeSelection(undefined);
      return;
    }

    let selectedProviders: Provider[] = [];

    if (props.MultiselectEnable) {
      selectedProviders = props.Providers?.filter((provider: Provider) => data.selectedOptions.includes(provider.person.businessName) || data.selectedOptions.includes(provider.person.personIdentifier)) ?? [];
      setSelectedOptions(data.selectedOptions);
      setInternalProtocolPatientsSelected(selectedProviders);
    } else {
      selectedProviders = [props.Providers?.find((provider: Provider) => provider.person.businessName === data.value || provider.person.personIdentifier === data.value) as Provider ?? []];
      setSelectedOptions(props.MultiselectEnable ? [data.value] : (selectedOptions.includes(data.value) ? [] : [data.value]));
      setInternalProtocolPatientsSelected(selectedProviders);
    }

    props.onChangeSelection && props.onChangeSelection(selectedProviders);

  };

  useEffect(() => {
    if(props.ProviderSelected && props.ProviderSelected.length > 0) {
      const selectedProviders: Provider[] = [];
      props.ProviderSelected.forEach(selected => {
        const provider = props.Providers?.find((provider: Provider) => provider.person.businessName === selected || provider.person.personIdentifier === selected);
        if (provider) {
          selectedProviders.push(provider);
        }
      });
      setInternalProtocolPatientsSelected(selectedProviders);
      const selectedNames = selectedProviders.map(provider => provider.person.businessName);
      setSelectedOptions(selectedNames);
    }
  }, [props.ProviderSelected]);

  const tagPickerOptions = props.Providers?.map((provider) => provider.person.businessName)?.filter(
    (provider: string) => !selectedOptions.includes(provider)
  );

  return (
    <div>
      <Field label="Seleccione un proveedor" style={{ maxWidth: 400 }}>
        <TagPicker
          onOptionSelect={onOptionSelect}
          selectedOptions={selectedOptions}
        >
          <TagPickerControl>
            <TagPickerGroup aria-label="Proveedores Seleccionados">
              {selectedOptions.map((option) => (
                <Tag
                  key={option}
                  media={
                    <Avatar
                      shape="circular"
                      aria-hidden
                      name={option}
                      color="colorful"
                    />
                  }
                  value={option}
                >
                  {option}
                </Tag>
              ))}
            </TagPickerGroup>
            <TagPickerInput aria-label="Seleccione un proveedor" />
            {props.isLoading && (
              <Spinner size="extra-tiny" style={{ marginLeft: 8 }} />
            )}
          </TagPickerControl>
          <TagPickerList>
            {tagPickerOptions?.length > 0 ? (
              tagPickerOptions?.map((option) => (
                <TagPickerOption
                  media={
                    <Avatar
                      shape="circular"
                      aria-hidden
                      name={option}
                      color="colorful"
                    />
                  }
                  value={option}
                  key={option}
                >
                  {option}
                </TagPickerOption>
              ))
            ) : (
              <TagPickerOption value="no-options">
                No hay conceptos disponibles
              </TagPickerOption>
            )}
          </TagPickerList>
        </TagPicker>
      </Field>
    </div>
  );
};

export default connect (
  Functions.mapStateToProps,
  Functions.mapDispatchToProps
) (ProviderSelectorComponent as any);
